module.exports = __webpack_public_path__ + "static/media/uzemi_epulet_rakosliget.c950e525.jpg";